export default "__VITE_ASSET__D3dmjjj3__"